import React from "react";
import { TrendingUp } from "lucide-react";
import VerticalPage from "@/pages/VerticalPage";

const TYPE_OPTIONS = [
  { value: "stock",         label: "Stock" },
  { value: "mutual_fund",   label: "Mutual fund" },
  { value: "fixed_deposit", label: "Fixed deposit" },
  { value: "crypto",        label: "Crypto" },
  { value: "gold",          label: "Gold / Bullion" },
  { value: "real_estate",   label: "Real estate" },
  { value: "bond",          label: "Bond" },
  { value: "other",         label: "Other" },
];

const FORMAT_INR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return null;
  try { return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n)); }
  catch { return `₹${Number(n).toLocaleString("en-IN")}`; }
};

export default function Investments() {
  return (
    <VerticalPage
      title="Investments"
      subtitle="Stocks, MFs, FDs — track it all"
      endpoint="/investments"
      singularType="investment"
      icon={TrendingUp}
      colorClass="text-emerald-500 bg-emerald-500/12"
      emptySubtitle="Log any investment — shares, MFs, FDs, gold, crypto — with values and docs."
      typeField={{ name: "inv_type", label: "Type", options: TYPE_OPTIONS }}
      sections={[
        {
          title: "Details",
          fields: [
            { name: "title",           label: "Name",             type: "text",   placeholder: "e.g. HDFC Bank Ltd", required: true, colSpan: 2 },
            { name: "provider",        label: "Broker / AMC",     type: "text",   placeholder: "e.g. Zerodha" },
            { name: "units",           label: "Units / Qty",      type: "number", placeholder: "e.g. 32" },
            { name: "invested_amount", label: "Invested (₹)",     type: "number", placeholder: "50000" },
            { name: "current_value",   label: "Current value (₹)",type: "number", placeholder: "62000" },
            { name: "purchased_at",    label: "Purchased on",     type: "date" },
            { name: "maturity_date",   label: "Maturity date",    type: "date" },
            { name: "notes",           label: "Notes",            type: "textarea", placeholder: "Optional notes", colSpan: 2 },
          ],
        },
      ]}
      formatMeta={(it) => {
        const typeLbl = TYPE_OPTIONS.find((o) => o.value === it.inv_type)?.label;
        const invested = FORMAT_INR(it.invested_amount);
        const current  = FORMAT_INR(it.current_value);
        const line1 = [typeLbl, it.provider].filter(Boolean).join(" · ");
        const line2 = [invested && `Invested ${invested}`, current && `Now ${current}`].filter(Boolean).join(" · ");
        return { line1, line2, badge: typeLbl ? undefined : null };
      }}
    />
  );
}
